._ReportingView_xbv4c_1 {
  /* Empty file & class, used as a placeholder for future styling */
}